

import IconClaude from "@/assets/images/new/icon_claude.svg";
import IconGpt from "@/assets/images/new/icon_gpt.svg";
import IconKimi from "@/assets/images/new/icon_kimi.svg";
import IconGemini from "@/assets/images/new/icon_gemini.svg";
import IconGpt35 from "@/assets/images/new/icon_gpt3.5.svg";
import IconDalle from "@/assets/images/new/icon_dalle.svg";
import IconQwen from "@/assets/images/new/icon_qw.svg";
import IconWxin from "@/assets/images/new/icon_wxyy.svg";
import IconXhuo from "@/assets/images/new/icon_xh.svg";
import IconSuno from "@/assets/images/new/icon_suno.svg";
import IconLlama from '@/assets/images/new/icon_llama.svg'


// value的改动会影响用户缓存chatEngine和历史记录
/*
  name 前端显示
  value 后台传值
  icon 图标
  docSupport 支持文档
  imageSupport 支持图片
  webMode 联网模式
  enhanceMode 增强模式
  madeInChina 国产大模型
  single 单选
*/
export const engineList = [
    {
      name: "GPT-4.5",
      value: "gpt-4",
      version: 'gpt-4-turbo-2024-04-09',
      icon: IconGpt,
      docSupport: true,
      imageSupport: true,
      webMode: true,
      enhanceMode: true
    }, 
    {
      name: "Claude-3 Opus",
      value: "claude-3-opus",
      version: 'claude-3-opus-20240229',
      icon: IconClaude,
      docSupport: false,
      imageSupport: true,
    },
    {
      name: "文心4.0", 
      value: "ERNIE-4.0",
      version: 'ERNIE-4.0',
      icon: IconWxin,
      docSupport: false,
      imageSupport: false,
      madeInChina: true
    },
    {
      name: "Gemini 1.5 Pro",
      value: "gemini-pro",
      version: 'gemini-pro-1.5',
      icon: IconGemini,
      docSupport: false,
      imageSupport: true,
    },
    {
      name: "Llama-3",
      value: "llama-3",
      version: 'llama-3-70b',
      icon: IconLlama,
      docSupport: false,
      imageSupport: false,
    },
    {
      name: "Claude-3 Sonnet",
      value: "claude-3-sonnet",
      version: 'claude-3-sonnet-20240229',
      icon: IconClaude,
      docSupport: false,
      imageSupport: true,
    },
    {
      name: "Claude-3 Haiku",
      value: "claude-3-haiku",
      version: 'claude-3-haiku-20240229',
      icon: IconClaude,
      docSupport: false,
      imageSupport: false,
    },
    {
      name: "GPT-3.5",
      value: "gpt-3.5",
      version: 'gpt-3.5-turbo-0125',
      icon: IconGpt35,
      docSupport: false,
      imageSupport: false,
    },
    // add 4-14
    {
      name: "通义千问", 
      value: "qwen",
      version: 'qwen-max',
      icon: IconQwen,
      docSupport: false,
      imageSupport: false,
      madeInChina: true
    },
    {
      name: "文心3.5", 
      value: "ERNIE-3.5",
      version: 'ERNIE-3.5',
      icon: IconWxin,
      docSupport: false,
      imageSupport: false,
      madeInChina: true
    },
    {
      name: "Kimi",
      value: "moonshot",
      version: 'moonshot-v1',
      icon: IconKimi,
      docSupport: false,
      imageSupport: false,
      madeInChina: true
    },
    {
      name: "星火", 
      value: "SparkDesk",
      version: 'SparkDesk-v3.5',
      icon: IconXhuo,
      docSupport: false,
      imageSupport: false,
      madeInChina: true
    },
    {
      name: "Suno V3音乐生成", 
      value: "suno",
      version: 'chirp-v3-0',
      icon: IconSuno,
      docSupport: false,
      imageSupport: false,
      single: true
    },
    {
      name: "GPT画图", 
      value: "dall-e",
      version: 'dall-e-3',
      icon: IconDalle,
      docSupport: false,
      imageSupport: true,
      single: true
    },
  ]
  // 所有value列表
  export const engineValueList = engineList.map(e => e.value)
  // 单选列表
  export const engineSingleValueList = engineList.filter(e => e.single).map(e => e.value)


  export const sunoTagList = [
    { label: '流行', value: 'pop'},
    { label: '爵士', value: 'jazz'},
    { label: 'R&B', value: 'R&B'},
    { label: '摇滚', value: 'Rock'},
    { label: '放克', value: 'Funk'},
    { label: '韩流', value: 'Kpop'},
    { label: '布鲁斯', value: 'Blues'},
    { label: '雷鬼', value: 'Reggae'},
    { label: '乡村', value: 'Country'},
    { label: '说唱', value: 'Rap'},
  ]